import type { BlogPost } from '../../../../../../../types';

export const shouldRenderCover = (media: BlogPost['media']) => {
  return !!(
    media?.wixMedia?.image ||
    media?.wixMedia?.videoV2?.posters?.[0] ||
    media?.embedMedia?.thumbnail
  );
};
